import { useEffect, useRef, useState } from 'react';
import GetStarted from '../../components/form-new/GetStarted';
import FlexComponent from '../../components/FlexComponent';
import './form.css';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import WorkHistory from '../../components/form-new/WorkHistory';
import HowMuchMoneySaved from '../../components/form-new/HowMuchMoneySaved';
import YourCredit from '../../components/form-new/YourCredit';
import AddressHistory from '../../components/form-new/AddressHistory';
import ContactInformation from '../../components/form-new/ContactInformation';
import WhatTypeOfHome from '../../components/form-new/WhatTypeOfHome';
import CoSignerInfo from '../../components/form-new/CoSignerInfo';
import InternalDetails from '../../components/form-new/InternalDetails';
import axios, { refreshCloudfrontCookies } from '../../utils/axios';
import { useSelector } from 'react-redux';
import { form_submit, getAvailableUsers, new_form_submit, get_form_initials, sendMessage, checkAppExists } from '../../utils/urls';
import Swal from 'sweetalert2';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Avatar } from 'primereact/avatar';
import { OverlayPanel } from 'primereact/overlaypanel';
import OtherIncome from '../../components/form-new/OtherIncome';

const formSchema = yup.object().shape({
    firstName: yup.string().trim().required('required'),
    lastName: yup.string().trim().required('required'),
    language: yup.string().required('required'),
    work_history: yup.array().min(1, 'work history is Required').required('This field is required'),
    // address_history: yup.array().min(1, 'Address is Required').required('This field is required'),
    total_amount_saved: yup.number().required('required'),
    estimated_credit_score: yup.number().required('required'),
    cell_phone_number: yup
        .string()
        .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Cell phone number must be in the format (xxx) xxx-xxxx')
        .required('Cell phone number is required'),
    // email: yup.string().email('invalid email').required('required'),
    lead_source: yup.string().required('required'),
    which_homes_for_sale_region: yup.string().required('required'),
    application_pipeline: yup.string().required('required'),
    application_by: yup.string().required('required'),
});

function NewDesignedForm() {
    const [locationData, setLocationData] = useState();
    const [ghlUserId, setGhlUserId] = useState(null);
    const toast = useRef(null);
    const userId = useSelector((state) => state.user.userId);
    const bizCardUrl = useSelector((state) => state.user.bizCardUrl);
    const locationCardUrl = useSelector((state) => state.user.locationCardUrl);
    const [loading, setLoading] = useState(false);
    const [languageSelect, setLanguageSelect] = useState('');
    const [availableUsers, setAvailableUsers] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);
    const availableOp = useRef(null);
    const sendOp = useRef(null);
    const [formListView, setFormListView] = useState(() => {
        const savedView = localStorage.getItem('formListView');
        return savedView ? JSON.parse(savedView) : true;
    });

    const [submissionError, setSubmissionError] = useState(null)
    const [sendContactId, setSendContactId] = useState('')
    const [sendMessageLoading, setSendMessageLoading] = useState('')
    const isSuperuser = useSelector((state) => state.user.isSuperuser);

    const handleSendMessage = async (tag, language, locationId) => {
        if (!sendContactId.trim()) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please enter a Contact ID', life: 2000 });
            return;
        }
        if (!locationId) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select a location first', life: 2000 });
            return;
        }
        setSendMessageLoading(tag);
        try {
            const response = await axios.post(sendMessage, {
                locationId,
                contactId: sendContactId.trim(),
                userId,
                language,
                tag,
            }, { headers: { 'Content-Type': 'application/json' } });
            if (response.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: response.data?.message || 'Sent successfully', life: 3000 });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
        } finally {
            setSendMessageLoading('');
        }
    };

    const formSteps = [
        {
            id: 'getStarted',
            component: GetStarted,
            title: 'Applicant',
            fields: [
                'firstName',
                'lastName',
                'language',
                'email',
                'cell_phone_number',
                'lead_source',
                'which_homes_for_sale_region',
                'application_pipeline',
                'application_by',
            ],
        },
        { id: 'workAndIncome', component: WorkHistory, title: 'Work History', fields: ['work_history'] },
        { id: 'otherIncome', component: OtherIncome, title: 'Other Income', fields: [] },
        { id: 'savingsAssets', component: HowMuchMoneySaved, title: 'Money Saved', fields: ['total_amount_saved'] },
        { id: 'YourCredit', component: YourCredit, title: 'Credit', fields: ['estimated_credit_score'] },
        { id: 'addressId', component: AddressHistory, title: 'Address History', fields: [] },
        // { id: 'contactId', component: ContactInformation, title: 'Contact', fields: [] },
        { id: 'homeTypeId', component: WhatTypeOfHome, title: 'Assets', fields: [] },
        { id: 'cosignerId', component: CoSignerInfo, title: 'Cosigner', fields: [] },
        // { id: 'internalDetailsId', component: InternalDetails, title: 'Internal Details', fields: ['lead_source', 'which_homes_for_sale_region', 'application_pipeline', 'application_by'] },
    ];

    function changeIncomeColor(values) {
        try {
            const applicantIncome = values.work_history?.find((work) => work.status)?.yearly_income;
            if (applicantIncome) {
                if (applicantIncome >= 80000) return '#00C896';
                else if (applicantIncome < 80000 && applicantIncome >= 65000) return '#FFB400';
                else return '#FF4E4E';
            }
        } catch (error) {
            return '';
        }
    }

    function changeCreditColor(applicantCredit) {
        try {
            const credit = parseInt(applicantCredit);
            if (isNaN(credit)) return '';
            if (credit >= 620) return '#00C896';
            else if (credit < 620 && credit >= 500) return '#FFB400';
            else return '#FF4E4E';
        } catch (error) {
            return '';
        }
    }

    function changeAvailableColor(cashAvailable) {
        try {
            if (isNaN(cashAvailable)) return '';
            if (cashAvailable >= 45000) return '#00C896';
            else if (cashAvailable < 45000 && cashAvailable >= 20000) return '#FFB400';
            else if (cashAvailable) return '#FF4E4E';
        } catch (error) {
            return '';
        }
    }

    const initialValues = {
        work_history: [],
        address_history: [],
        cosigner_list: [],
        estimated_credit_score: '',
        specific_area_interested_in: [],
        firstName: '',
        middleName: '',
        lastName: '',
        language: '',
        have_you_been_preapproved: '',
        cell_phone_number: '',
        email: '',
        MaritalStatus: '',
        work_history_gap_explanation: '',
        other_source_of_incomes: [],
        savings_in_the_bank: '',
        savings_in_cash: '',
        gifts_from_family_amount: '',
        investments_or_life_insurance_amount: '',
        retirement_amount: '',
        other_savings_amount: '',
        specify_other_savings_amount_source: '',
        total_amount_saved: '',
        date_of_birth: '',
        social_security_no: '',
        home_type: [],
        bedrooms: '',
        bathrooms: '',
        do_you_have_price_range_in_mind: '',
        do_you_have_a_cosigner: '',
        purchase_type: '',
        notes_about_home_search: '',
        lead_source: '',
        which_homes_for_sale_region: '',
        application_pipeline: '',
        application_by: '',
        prospecting_account : ''
    };

    const formatDate = (date) => {
        if (!date) return '';
        const parsedDate = typeof date === 'string' ? new Date(date) : date;
        if (!(parsedDate instanceof Date) || isNaN(parsedDate.getTime())) return '';
        const year = parsedDate.getFullYear();
        const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
        const day = String(parsedDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleFormSubmit = async (values, onSubmitProps) => {
        try {
            setLoading(true);
            const { otherLanguage, other_lead_source, ...data } = values;
            data.form_name = 'New App';
            data.language = data.language === 'Other' ? otherLanguage : data.language;
            data.lead_source = data.lead_source === 'Other' ? other_lead_source : data.lead_source;
            data.date_of_birth = formatDate(data.date_of_birth);

            data.cosigner_list = data.cosigner_list.map((cosigner) => {
                const updatedWorkHistory = cosigner.work_history && Array.isArray(cosigner.work_history)
                    ? cosigner.work_history.map((work) => ({
                        ...work,
                        start_date: work.start_date ? formatDate(work.start_date) : '',
                        end_date: work.end_date ? formatDate(work.end_date) : ''
                    }))
                    : [];

                const updatedAddressHistory = cosigner.address_history && Array.isArray(cosigner.address_history)
                    ? cosigner.address_history.map((address) => ({
                        ...address,
                        move_in_date: address.move_in_date ? formatDate(address.move_in_date) : '',
                        move_out_date: address.move_out_date ? formatDate(address.move_out_date) : ''
                    }))
                    : [];

                return {
                    ...cosigner,
                    work_history: updatedWorkHistory,
                    address_history: updatedAddressHistory,
                    cb_DOB: cosigner.cb_DOB ? formatDate(cosigner.cb_DOB) : '',
                    cosigner_cell_phone_number: cosigner.cosigner_cell_phone_number ? parseInt(cosigner.cosigner_cell_phone_number?.replace(/\D/g, '')) : ''
                };
            });

            if (data.cosigner_list.length > 0) {
                data.do_you_have_a_cosigner = 'Yes';
            } else {
                data.do_you_have_a_cosigner = 'No';
            }

            data.cell_phone_number = parseInt(data.cell_phone_number?.replace(/\D/g, '')) || '';
            data.cell_number_of_lead = parseInt(data.cell_number_of_lead?.replace(/\D/g, '')) || '';
            data.work_history = data.work_history.map(({ start_date, end_date, status, ...entry }) => ({
                ...entry,
                start_date: start_date ? formatDate(start_date) : '',
                end_date: end_date ? formatDate(end_date) : '',
                status: status === "true"
            }));

            data.address_history = data.address_history.map(({ move_in_date, move_out_date, ...entry }) => ({
                ...entry,
                move_in_date: move_in_date ? formatDate(move_in_date) : '',
                move_out_date: move_out_date ? formatDate(move_out_date) : ''
            }));

            console.log('submitted data', data);

            const checkRes = await axios.post(checkAppExists, {
                email: data.email || '',
                phone: data.cell_phone_number ? String(data.cell_phone_number) : '',
            });
            if (checkRes.data?.app_exists) {
                const proceed = await Swal.fire({
                    title: 'App Already Exists',
                    html: `<p style="margin:0">${checkRes.data.detail}</p>${checkRes.data.contact_url ? `<br/><a href="${checkRes.data.contact_url}" target="_blank" rel="noreferrer" style="color:#3085d6;font-size:0.9em">View Contact</a>` : ''}`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Proceed Anyway',
                    cancelButtonText: 'Cancel',
                });
                if (!proceed.isConfirmed) {
                    setLoading(false);
                    return;
                }
            }
            const response = await axios.post(new_form_submit, data, {
                headers: { 'Content-Type': 'application/json' },
            });
            if (response.status === 200) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Form Submitted Successfully',
                    showConfirmButton: false,
                    timer: 1500,
                });
                setLoading(false);
                onSubmitProps.resetForm();
                setSubmissionError(null)
                await refreshCloudfrontCookies()
            } else {
                const msg = response.data;
                const errText = typeof msg === 'string' ? msg : (msg?.detail || msg?.message || 'Something went wrong. Please try again');
                setLoading(false);
                setSubmissionError(errText)
            }
        } catch (error) {
            const msg = error.response?.data;
            const errText = typeof msg === 'string' ? msg : (msg?.detail || msg?.message || 'Something went wrong. Please try again');
            console.log('error', error);
            setLoading(false);
            setSubmissionError(errText)
        }
    };

    const getLocationList = async () => {
        if (userId) {
            try {
                const response = await axios.get(`${get_form_initials}?userId=${userId}`, {
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.status === 200) {
                    const data = response.data;
                    const mergedData = [...data.location_user_data];
                    setLocationData(mergedData);
                    setGhlUserId(data.ghl_user_id);
                }
            } catch (error) {
                console.error('Error fetching location list:', error);
            }
        }
    };

    const getAvailableUsersList = async () => {
        if (languageSelect) {
            try {
                const response = await axios.get(`${getAvailableUsers}?type=Live Assignment&language=${languageSelect}`, {
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.status === 200) {
                    setAvailableUsers(response.data);
                }
            } catch (error) {
                console.error('Error fetching available users:', error);
            }
        }
    };

    const handleClick = (event, id) => {
        event.preventDefault();
        let element = document.getElementById(id);
        if (!element && id === 'cosignerId') {
            element = document.getElementById('cosignerQuestionId');
        }
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            window.scrollTo({ top: absoluteElementTop - 120, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        localStorage.setItem('formListView', JSON.stringify(formListView));
        setLoading(false);
    }, [formListView]);

    useEffect(() => {
        getLocationList();
    }, [get_form_initials, userId]);

    useEffect(() => {
        getAvailableUsersList();
    }, [languageSelect]);

    function getCurrentYearlyIncome(values) {
        try {
            let totalIncome = 0;

            // Calculate applicant's work history income
            if (values.work_history && Array.isArray(values.work_history)) {
                totalIncome += values.work_history
                    .filter((work) => work.status === "true")
                    .reduce((sum, work) => sum + (parseFloat(work.yearly_income) || 0), 0);
            }

            // Calculate co-borrowers' work history income
            if (values.cosigner_list && Array.isArray(values.cosigner_list)) {
                values.cosigner_list.forEach((cosigner) => {
                    if (cosigner.work_history && Array.isArray(cosigner.work_history)) {
                        totalIncome += cosigner.work_history
                            .filter((work) => work.status === "true")
                            .reduce((sum, work) => sum + (parseFloat(work.yearly_income) || 0), 0);
                    }
                });
            }

            return totalIncome;
        } catch (error) {
            console.error('Error calculating current yearly income:', error);
            return 0;
        }
    }

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map((word) => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    function formatNumber(number) {
        if (number) {
            const num = parseInt(number, 10);
            if (isNaN(num)) return '';
            if (num >= 1000 && num < 1000000) return (num / 1000).toFixed(1) + 'k';
            else if (num >= 1000000 && num < 1000000000) return (num / 1000000).toFixed(1) + 'M';
            else if (num >= 1000000000) return (num / 1000000000).toFixed(1) + 'B';
            else return num.toString();
        }
    }

    const hasStepErrors = (stepIndex, errors) => {
        const stepFields = formSteps[stepIndex].fields;
        return stepFields.some((field) => errors[field]);
    };

    const handleNext = (event) => {
        event.preventDefault();
        if (currentStep < formSteps.length - 1) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handlePrevious = (event) => {
        event.preventDefault();
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    return (
        <div>
            <Toast ref={toast} />
            <div className="newDesignedForm" style={{ background: 'white', position: 'relative' }}>
                <FlexComponent style={{ background: 'black' }}>
                    <div style={{ color: 'white', padding: '1rem 5.2%', fontSize: '18px' }}>New Mortgage App</div>
                    <Button
                        style={{ background: 'white', color: 'black', marginRight: '2rem', padding: '.5rem' }}
                        type="button"
                        onClick={() => setFormListView(!formListView)}
                        aria-label="Toggle between slide and full form views"
                    >
                        {formListView ? 'Show Slide View' : 'Show Full View'}
                    </Button>
                </FlexComponent>
                <Formik
                    onSubmit={(values, actions) => {
                        handleFormSubmit(values, actions).catch(() => {
                            toast.current.show({
                                severity: 'error',
                                summary: 'Submission Error',
                                detail: 'Please ensure all required fields are filled correctly.',
                                life: 3000,
                            });
                        });
                    }}
                    initialValues={initialValues}
                    validationSchema={formSchema}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleChange,
                        setFieldValue,
                        handleSubmit,
                        isSubmitting,
                        validateForm,
                    }) => (
                        <form onSubmit={handleSubmit} >
                            <FlexComponent className="formContainerDiv" style={{ width: '100%', padding: '1rem .5rem' }}>
                                <FlexComponent style={{ width: '74%', marginLeft: "4.8%" }} alignItems="end">
                                    {!formListView &&
                                        formSteps.map((step, index) => (
                                            <div
                                                key={step.id}
                                                style={{
                                                    height: '35px',
                                                    borderBottom: currentStep === index ? '5px solid black' : 'none',
                                                    paddingBottom: '5px',
                                                }}
                                                className={currentStep === index ? 'activeStep' : 'notActiveStep'}
                                            >
                                                <a
                                                    style={{
                                                        cursor: 'pointer',
                                                        textDecoration: 'none',
                                                        color:
                                                            hasStepErrors(index, errors) && step.fields.some((field) => touched[field] && errors[field])
                                                                ? 'red'
                                                                : 'black',
                                                    }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setCurrentStep(index);
                                                    }}
                                                >
                                                    {step.title}
                                                </a>
                                            </div>
                                        ))}
                                </FlexComponent>
                                <FlexComponent
                                    className="incomeCreditMobileView"
                                    style={{ width: '50%' }}
                                    justifyContent="end"
                                    alignItems="end"
                                    gap=".8rem"
                                >
                                    <div>
                                        <p
                                            style={{
                                                fontFamily: 'DINCondensedC',
                                                textAlign: 'center',
                                                color: changeIncomeColor(values),
                                                fontSize: '24px',
                                            }}
                                        >
                                            {formatNumber(getCurrentYearlyIncome(values)) || 0}
                                        </p>
                                        <p>Income</p>
                                    </div>
                                    <div>
                                        <p
                                            style={{
                                                fontFamily: 'DINCondensedC',
                                                textAlign: 'center',
                                                color: changeCreditColor(values?.estimated_credit_score || ''),
                                                fontSize: values?.estimated_credit_score.length > 5 ? '12px' : '24px',
                                            }}
                                        >
                                            {values?.estimated_credit_score || 0}
                                        </p>
                                        <p>Credit</p>
                                    </div>
                                    <div>
                                        <p
                                            style={{
                                                fontFamily: 'DINCondensedC',
                                                textAlign: 'center',
                                                color: changeAvailableColor(values?.total_amount_saved || ''),
                                                fontSize: '24px',
                                            }}
                                        >
                                            {formatNumber(values?.total_amount_saved) || 0}
                                        </p>
                                        <p>Available</p>
                                    </div>
                                </FlexComponent>
                                {availableUsers.length > 0 && (
                                    <div className="availableUsersMobile">
                                        <Button
                                            type="button"
                                            style={{ width: '150px', marginLeft: '1rem' }}
                                            onClick={(e) => availableOp.current.toggle(e)}
                                        >
                                            Available Users
                                        </Button>
                                        <OverlayPanel ref={availableOp} style={{ background: '#1A2B53' }}>
                                            {availableUsers.length > 0 && (
                                                <div style={{ color: 'white' }}>
                                                    <h3>Available Users</h3>
                                                    {availableUsers.map((user) => (
                                                        <FlexComponent style={{ marginTop: '.5rem' }} justifyContent="start" key={user.id}>
                                                            <Avatar
                                                                image={user.image}
                                                                size="small"
                                                                label={<span style={{ padding: '5px' }}>{getInitials(user?.name)}</span>}
                                                                shape="circle"
                                                                style={{ marginRight: '8px' }}
                                                            />
                                                            {user.name}
                                                        </FlexComponent>
                                                    ))}
                                                </div>
                                            )}
                                        </OverlayPanel>
                                    </div>
                                )}
                            </FlexComponent>
                            <FlexComponent className="formDiv" justifyContent="end" alignItems="start" gap="1rem">
                                {!formListView ? (
                                    <FlexComponent
                                        className="inputFlexContainer formFlexDiv"
                                        flexDirection="column"
                                        style={{
                                            minHeight: '60vh',
                                            zIndex: '1',
                                            // background: 'white',
                                            // boxShadow: '0px 4px 10px 4px rgb(0 0 0 / 20%)',
                                            borderRadius: '15px',
                                            width: "80%"
                                        }}
                                    >
                                        {currentStep === 0 && (
                                            <GetStarted
                                                formName="New App"
                                                setLanguageSelect={setLanguageSelect}
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                handleBlur={handleBlur}
                                                handleChange={handleChange}
                                                locationData={locationData}
                                                ghlUserId={ghlUserId}
                                                setFieldValue={setFieldValue}
                                                toast={toast}
                                                onContactIdSync={(id) => setSendContactId(id)}
                                            />
                                        )}
                                        {currentStep === 1 && (
                                            <WorkHistory
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                handleBlur={handleBlur}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                            />
                                        )}
                                        {currentStep === 2 && (
                                            <OtherIncome
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                handleBlur={handleBlur}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                            />
                                        )}
                                        {currentStep === 3 && (
                                            <HowMuchMoneySaved
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                handleBlur={handleBlur}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                            />
                                        )}
                                        {currentStep === 4 && (
                                            <YourCredit
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                handleBlur={handleBlur}
                                                handleChange={handleChange}
                                            />
                                        )}
                                        {currentStep === 5 && (
                                            <AddressHistory
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                handleBlur={handleBlur}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                                toast={toast}
                                            />
                                        )}
                                        {currentStep === 6 && (
                                            <WhatTypeOfHome
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                handleBlur={handleBlur}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                            />
                                        )}
                                        {currentStep === 7 && (
                                            <CoSignerInfo
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                handleBlur={handleBlur}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                            />
                                        )}

                                        <FlexComponent justifyContent="space-between" style={{ padding: '1rem' }}>
                                            <Button
                                                type="button"
                                                label="Previous"
                                                onClick={handlePrevious}
                                                disabled={currentStep === 0}
                                                style={{ background: 'black', marginLeft: "5.8%" }}
                                            />
                                            {currentStep === formSteps.length - 1 ? (
                                                <Button
                                                    label="Submit"
                                                    type="submit"
                                                    style={{ background: 'black' }}
                                                    icon="pi pi-check"
                                                    loading={loading}
                                                // disabled={isSubmitting}
                                                />
                                            ) : (
                                                <Button
                                                    type="button"
                                                    label="Next"
                                                    onClick={handleNext}
                                                    style={{ background: 'black' }}
                                                />
                                            )}
                                        </FlexComponent>
                                    </FlexComponent>
                                ) : (
                                    <FlexComponent
                                        className="inputFlexContainer formFlexDiv"
                                        flexDirection="column"
                                        style={{
                                            minHeight: '60vh',
                                            zIndex: '1',
                                            // background: 'white',
                                            // boxShadow: '0px 4px 10px 4px rgb(0 0 0 / 20%)',
                                            borderRadius: '15px',
                                            width: "80%"
                                        }}
                                    >
                                        <GetStarted
                                            formName="New App"
                                            setLanguageSelect={setLanguageSelect}
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                            locationData={locationData}
                                            ghlUserId={ghlUserId}
                                            setFieldValue={setFieldValue}
                                            toast={toast}
                                            onContactIdSync={(id) => setSendContactId(id)}
                                        />
                                        <WorkHistory
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                        />
                                        <OtherIncome
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                        />
                                        <HowMuchMoneySaved
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                        />
                                        <YourCredit
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                        />
                                        <AddressHistory
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            toast={toast}
                                        />
                                        <WhatTypeOfHome
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                        />
                                        <CoSignerInfo
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                        />

                                        <FlexComponent justifyContent="center" style={{ padding: '1rem' }}>
                                            <Button
                                                label="Submit"
                                                type="submit"
                                                style={{ background: 'black' }}
                                                icon="pi pi-check"
                                                loading={loading}
                                                // disabled={isSubmitting}
                                            />
                                        </FlexComponent>
                                        {submissionError && <div style={{color: "red", padding: "0 0 3rem 0"}}>{submissionError}</div>}
                                    </FlexComponent>
                                )}
                                <FlexComponent
                                    className="navigationClass"
                                    flexDirection="column"
                                    style={{ width: '20%', marginTop: '.2rem' }}
                                >
                                    <FlexComponent justifyContent="center" alignItems="end" gap=".8rem">
                                        <div>
                                            <p
                                                style={{
                                                    fontFamily: 'DINCondensedC',
                                                    textAlign: 'center',
                                                    color: changeIncomeColor(values),
                                                    fontSize: '24px',
                                                }}
                                            >
                                                {formatNumber(getCurrentYearlyIncome(values)) || 0}
                                            </p>
                                            <p>Income</p>
                                        </div>
                                        <div>
                                            <p
                                                style={{
                                                    fontFamily: 'DINCondensedC',
                                                    textAlign: 'center',
                                                    color: changeCreditColor(values?.estimated_credit_score || ''),
                                                    fontSize: values?.estimated_credit_score.length > 5 ? '12px' : '24px',
                                                }}
                                            >
                                                {values?.estimated_credit_score || 0}
                                            </p>
                                            <p>Credit</p>
                                        </div>
                                        <div>
                                            <p
                                                style={{
                                                    fontFamily: 'DINCondensedC',
                                                    textAlign: 'center',
                                                    color: changeAvailableColor(values?.total_amount_saved || ''),
                                                    fontSize: '24px',
                                                }}
                                            >
                                                {formatNumber(values?.total_amount_saved) || 0}
                                            </p>
                                            <p>Available</p>
                                        </div>
                                    </FlexComponent>
                                    <div style={{ width: '100%', padding: '.5rem 0' }}>
                                        {/* <label style={{ fontSize: '12px', display: 'block', marginBottom: '.25rem' }}>Contact ID</label> */}
                                        <FlexComponent gap=".4rem" alignItems="center">
                                            <InputText
                                                value={sendContactId}
                                                onChange={(e) => setSendContactId(e.target.value)}
                                                placeholder="GHL Contact ID"
                                                style={{ flex: 1, fontSize: '12px' }}
                                            />
                                            <Button
                                                type="button"
                                                label="Send"
                                                style={{ background: 'black', fontSize: '12px', whiteSpace: 'nowrap' }}
                                                disabled={!sendContactId.trim()}
                                                onClick={(e) => sendOp.current.toggle(e)}
                                            />
                                        </FlexComponent>
                                        <OverlayPanel ref={sendOp}>
                                            <FlexComponent flexDirection="column" gap=".4rem" alignItems="start">
                                                {bizCardUrl && (
                                                    <Button
                                                        type="button"
                                                        label="Send Biz Card"
                                                        style={{ width: '100%', fontSize: '12px', background: 'black' }}
                                                        loading={sendMessageLoading === 'send-bizcard'}
                                                        onClick={() => { sendOp.current.hide(); handleSendMessage('send-bizcard', values.language, values.which_homes_for_sale_region); }}
                                                    />
                                                )}
                                                {locationCardUrl && (
                                                    <Button
                                                        type="button"
                                                        label="Send Location Graphic"
                                                        style={{ width: '100%', fontSize: '12px', background: 'black' }}
                                                        loading={sendMessageLoading === 'send location graphic'}
                                                        onClick={() => { sendOp.current.hide(); handleSendMessage('send location graphic', values.language, values.which_homes_for_sale_region); }}
                                                    />
                                                )}
                                                <Button
                                                    type="button"
                                                    label="Send Spanish Document List"
                                                    style={{ width: '100%', fontSize: '12px', background: 'black' }}
                                                    loading={sendMessageLoading === 'send spanish document list'}
                                                    onClick={() => { sendOp.current.hide(); handleSendMessage('send spanish document list', 'spanish', values.which_homes_for_sale_region); }}
                                                />
                                                <Button
                                                    type="button"
                                                    label="Send English Document List"
                                                    style={{ width: '100%', fontSize: '12px', background: 'black' }}
                                                    loading={sendMessageLoading === 'send english document list'}
                                                    onClick={() => { sendOp.current.hide(); handleSendMessage('send english document list', 'english', values.which_homes_for_sale_region); }}
                                                />
                                            </FlexComponent>
                                        </OverlayPanel>
                                    </div>
                                    <FlexComponent
                                        style={{ width: '100%' }}
                                        flexDirection="column"
                                        alignItems="start"
                                    >
                                        {formSteps.map((step, index) => (
                                            <div key={step.id}>
                                                {(step.title === 'Work & Income' &&
                                                    (changeIncomeColor(values) === '#EB4243' || changeIncomeColor(values) === 'orange')) && (
                                                        <p
                                                            style={{
                                                                borderRadius: '5px',
                                                                color: 'blue',
                                                                fontSize: '10px',
                                                                border: '1px solid grey',
                                                                padding: '3px',
                                                            }}
                                                        >
                                                            Make sure you ask questions about any additional sources of income, and about a cosigner to
                                                            help strengthen this application
                                                        </p>
                                                    )}
                                                {(step.title === 'Savings & Assets' &&
                                                    (changeAvailableColor(values?.total_amount_saved) === 'red' ||
                                                        changeAvailableColor(values?.total_amount_saved) === '#FF9A00')) && (
                                                        <p
                                                            style={{
                                                                borderRadius: '5px',
                                                                color: 'blue',
                                                                fontSize: '10px',
                                                                border: '1px solid grey',
                                                                padding: '3px',
                                                            }}
                                                        >
                                                            Please make sure to ask all of the questions about savings including do they have any family
                                                            friends or relatives who has ever suggested they would be willing to help with a gift of cash
                                                            towards your down payment or closing costs, and dont forget to ask about any retirement
                                                            accounts, savings accounts, or investments they may have.
                                                        </p>
                                                    )}
                                            </div>
                                        ))}
                                    </FlexComponent>

                                    <FlexComponent style={{ width: '100%' }} flexDirection="column" alignItems="start">
                                        {formListView &&
                                            formSteps.map((step, index) => (
                                                <div
                                                    key={step.id}
                                                    style={{ paddingBottom: '5px' }}
                                                    className={currentStep === index ? 'activeStep' : 'notActiveStep'}
                                                >
                                                    <a
                                                        style={{
                                                            cursor: 'pointer',
                                                            textDecoration: 'none',
                                                            color:
                                                                hasStepErrors(index, errors) && step.fields.some((field) => touched[field] && errors[field])
                                                                    ? 'red'
                                                                    : 'black',
                                                        }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleClick(e, step.id);
                                                        }}
                                                    >
                                                        {step.title}
                                                    </a>
                                                </div>
                                            ))}
                                    </FlexComponent>

                                    {availableUsers.length > 0 && (
                                        <div>
                                            <h3>Available Users</h3>
                                            {availableUsers.map((user) => (
                                                <FlexComponent style={{ marginTop: '.5rem' }} justifyContent="start" key={user.id}>
                                                    <Avatar
                                                        image={user.image}
                                                        size="small"
                                                        label={<span style={{ padding: '5px' }}>{getInitials(user?.name)}</span>}
                                                        shape="circle"
                                                        style={{ marginRight: '8px' }}
                                                    />
                                                    {user.name}
                                                </FlexComponent>
                                            ))}
                                        </div>
                                    )}
                                </FlexComponent>
                            </FlexComponent>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
}

export default NewDesignedForm;